// extracted by mini-css-extract-plugin
export default {"postCard":"user-posts-skeleton_postCard__kzo+n"};